import styles from "./styles/supportedBy.module.scss";
import { ReactComponent as UpSteer } from "../assets/logos/upSteer.svg";
import { ReactComponent as MedTech } from "../assets/logos/medTech.svg";
import { ReactComponent as Forward } from "../assets/logos/forward.svg";
import { ReactComponent as EcoCme } from "../assets/logos/ecoCme.svg";

export const SupportedBy = () => {
  return (
    <div className={styles.supportersCoolio}>
      <div className={styles.text}>Supported by</div>
      <div className={styles.logos}>
        <UpSteer className={styles.logo} />
        <MedTech className={styles.logo} />
        <Forward className={styles.logo} />
        <EcoCme className={styles.logo} />
      </div>
    </div>
  );
};
